export enum PaymentInstrument {
  UPI = 'upi',
  UPIIntent = 'upi_intent',
  ParkplusWallet = 'parkplus_wallet',
  Netbanking = 'netbanking',
  Card = 'card',
  Cash = 'cash',
  AutopayUpi = 'upi_autopay',
  PayLater = 'pay_later',
  PayWithApp = 'pay_with_app',
  Wallet = 'wallet',
}
